import clsx from 'clsx'
import PropTypes from 'prop-types'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import 'react-lazy-load-image-component/src/effects/blur.css'

const Image = ({
  src,
  alt = '',
  caption = '',
  width = '100%',
  height = 'auto',
  effect = 'blur',
  className = '',
  outerClassName = ''
}) => {
  return (
    <figure className={clsx('max-w-full', outerClassName)}>
      <LazyLoadImage
        src={src}
        alt={alt}
        width={width}
        height={height}
        effect={effect}
        className={clsx('h-auto w-full object-cover', className)}
      />
      {caption && (
        <figcaption className='mt-2 text-center text-sm text-gray-600'>
          {caption}
        </figcaption>
      )}
    </figure>
  )
}

export default Image

Image.propTypes = {
  src: PropTypes.string.isRequired,
  alt: PropTypes.string,
  caption: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  effect: PropTypes.string,
  className: PropTypes.string,
  outerClassName: PropTypes.string
}
